webpackJsonp([130767191886648],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _rlaComponents = __webpack_require__(7);
	
	__webpack_require__(221);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _generatePostLayout = __webpack_require__(241);
	
	var _generatePostLayout2 = _interopRequireDefault(_generatePostLayout);
	
	var _LoadMore = __webpack_require__(461);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _helpers = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowsAdvance = 3;
	
	var NewsPage = function (_React$Component) {
	    _inherits(NewsPage, _React$Component);
	
	    function NewsPage(props) {
	        _classCallCheck(this, NewsPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    NewsPage.prototype.componentDidMount = function componentDidMount() {
	        var news = this.props.news;
	
	
	        var chunks = (0, _helpers.randomChunkArray)(news, 2, 4);
	
	        var layout = (0, _generatePostLayout2.default)(chunks);
	
	        this.setState({
	            rows: rowsAdvance,
	            chunkedNews: chunks,
	            layout: layout
	        });
	
	        //console.log(chunks);
	    };
	
	    NewsPage.prototype.handleClick = function handleClick() {
	        this.setState({
	            rows: this.state.rows + rowsAdvance
	        });
	    };
	
	    NewsPage.prototype.render = function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            chunkedNews = _state.chunkedNews,
	            rows = _state.rows,
	            layout = _state.layout;
	
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                _rlaComponents.Row,
	                { expanded: true, collapse: true },
	                chunkedNews && chunkedNews.slice(0, rows).map(function (items, i) {
	                    return layout[i](items);
	                })
	            ),
	            chunkedNews && chunkedNews.length > rows && _react2.default.createElement(
	                _LoadMore2.default,
	                { onClick: function onClick() {
	                        return _this2.handleClick();
	                    } },
	                "Load More"
	            )
	        );
	    };
	
	    return NewsPage;
	}(_react2.default.Component);
	
	exports.default = NewsPage;
	module.exports = exports["default"];

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__(6);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _NewsList = __webpack_require__(239);
	
	var _NewsList2 = _interopRequireDefault(_NewsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var AuthorsPage = function (_React$Component) {
	    _inherits(AuthorsPage, _React$Component);
	
	    function AuthorsPage() {
	        _classCallCheck(this, AuthorsPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    AuthorsPage.prototype.render = function render() {
	        if (this.props.data.allMarkdownRemark != undefined) {
	            var _props = this.props,
	                _props$data$allMarkdo = _props.data.allMarkdownRemark,
	                data = _props$data$allMarkdo.edges,
	                totalCount = _props$data$allMarkdo.totalCount,
	                transition = _props.transition;
	
	
	            var posts = data[0].node.fields.posts;
	
	            var postsCount = posts ? posts.length : 0;
	
	            var person = data[0].node.frontmatter.title;
	
	            //const { edges, totalCount } = this.props.data.allMarkdownRemark;
	            return _react2.default.createElement(
	                "div",
	                { style: transition && transition.style },
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            _HeaderBlock2.default,
	                            {
	                                fontSize: _theme2.default.pageHeaderSection.fontSize,
	                                padding: _theme2.default.pageHeaderSection.padding },
	                            postsCount,
	                            " post",
	                            postsCount === 1 ? "" : "s",
	                            " by",
	                            " ",
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                person
	                            )
	                        )
	                    )
	                ),
	                postsCount ? _react2.default.createElement(_NewsList2.default, { news: posts }) : null
	            );
	        } else {
	            return null;
	        }
	    };
	
	    return AuthorsPage;
	}(_react2.default.Component);
	
	AuthorsPage.propTypes = {
	    pathContext: _propTypes2.default.shape({
	        author: _propTypes2.default.string.isRequired
	    }),
	    data: _propTypes2.default.shape({
	        allMarkdownRemark: _propTypes2.default.shape({
	            totalCount: _propTypes2.default.number.isRequired,
	            edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	                node: _propTypes2.default.shape({
	                    fields: _propTypes2.default.shape({
	                        slug: _propTypes2.default.string.isRequired
	                    }),
	                    frontmatter: _propTypes2.default.shape({
	                        title: _propTypes2.default.string.isRequired
	                    })
	                })
	            }).isRequired)
	        })
	    })
	};
	
	AuthorsPage.defaultProps = {
	    data: {
	        allMarkdownRemark: {
	            totalCount: null,
	            edges: []
	        }
	    }
	};
	
	exports.default = AuthorsPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _reactAnimateOnScroll = __webpack_require__(230);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _helpers = __webpack_require__(12);
	
	var _NewsSummary = __webpack_require__(158);
	
	var _NewsSummary2 = _interopRequireDefault(_NewsSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastarrayIndex = null;
	
	exports.default = function (chunks) {
	    var result = new Array();
	
	    var layouts = {
	        0: [function () {
	            return null;
	        }],
	        1: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }],
	        2: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 8, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 8, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }],
	        3: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 3, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 3, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 50,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 6, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    )
	                )
	            );
	        }],
	        4: [function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 500,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 750,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[3].node || data[3],
	                            height: 500
	                        })
	                    )
	                )
	            );
	        }, function (data) {
	            return _react2.default.createElement(
	                _rlaComponents.Row,
	                { collapse: true, expanded: true },
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 0,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[0].node || data[0],
	                            height: 500
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 250,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[1].node || data[1],
	                            height: 500
	                        }),
	                        " "
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Column,
	                    { large: 4, collapse: true, expanded: true },
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 500,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[2].node || data[2],
	                            height: 250
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _reactAnimateOnScroll2.default,
	                        {
	                            animateIn: "fadeIn",
	                            delay: 750,
	                            animateOnce: true },
	                        _react2.default.createElement(_NewsSummary2.default, {
	                            story: data[3].node || data[3],
	                            height: 250
	                        }),
	                        " "
	                    )
	                )
	            );
	        }]
	    };
	
	    chunks.map(function (chunk, i) {
	        var layoutArray = layouts[chunk.length];
	        var getArrayIndex = function getArrayIndex() {
	            return (0, _helpers.random)(0, layoutArray.length - 1);
	        };
	        var arrayIndex = 0;
	
	        // make sure that there are no duplicate rows if possible
	        if (layoutArray.length > 1) {
	            arrayIndex = getArrayIndex();
	            while (arrayIndex == lastarrayIndex) {
	                arrayIndex = getArrayIndex();
	            }
	            lastarrayIndex = arrayIndex;
	        }
	
	        result.push(layoutArray[arrayIndex]);
	    });
	
	    return result;
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-authors-js-1011f4c358d6d39da4f9.js